var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"emojiCanvas",staticClass:"emoji-canvas"},[(_vm.loaded)?_c('div',_vm._l((_vm.emojiMap),function(emojiLocation){return _c('EmojiEntity',{key:_vm.emojiMap.id,attrs:{"emoji-location":emojiLocation,"container":_vm.$refs['emojiCanvas']}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }